export const genderTypes = [
  { label: "Masculino", value: "M" },
  { label: "Femenino", value: "F" },
  { label: "Prefiero no decirlo", value: "O" }
]
